import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "logOut",
  tabindex: "1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "d-flex p-4" }
const _hoisted_4 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteGroup"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_6 = { class: "modal-body d-flex justify-content-center" }

import Button from '@/components/button/index.vue'
import { useRoute, useRouter } from 'vue-router'
import { PATH } from '@/constants/index'

import { translate } from '@/languages/i18n'
import { useStore } from 'vuex'
import { removeCookie } from '@/utils'
import userService from '@/services/auth.service'
import { AUTH_STORE, COMMUNITY_STORE } from '@/store/constants'
import { onMounted, ref } from 'vue'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()
const modalLogout = ref()
onMounted(() => {
  modalLogout.value = new Modal(document.getElementById('logOut'))
})
const handleClickMenu = async (): void => {
  try {
    const div = document.querySelector('body')
    div.classList.remove('menu-open')
    modalLogout.value.hide()
    const path = route.path.split('/')[1]
    const data = path === 'alumni' ? await userService.alumniLogoutApi() : await userService.communityLogoutApi()
    if (data?.data?.success) {
      removeCookie(PATH[`${path}`].header)
      removeCookie(PATH[`${path}`].pathName)
      removeCookie('invited_code')
      removeCookie('invited_code_employee')
      removeCookie(`${PATH[`${path}`].path}-redirect-path`)
      removeCookie(`${PATH[`${path}`].header}-one-time`)
      removeCookie(`${PATH[`${path}`].path}-required-two-factor`)
      removeCookie(`__Secure-${PATH[`${path}`].path}_unique_user_id`)
      localStorage.removeItem('store')
      store.dispatch(AUTH_STORE.ACTIONS.SET_AUTH_VALUE, false)
      store.dispatch(COMMUNITY_STORE.ACTIONS.LOG_OUT)
      router.push({
        path: `/${path}${path === 'community' ? '/users' : ''}/login`,
      })
    }
  } catch (error) {
    console.log('logout', error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
        class: "modal-content"
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, _toDisplayString(_unref(translate)('areYouSure')), 1),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Button, {
              title: _unref(translate)('cancel'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2",
              className: 'fw-bold'
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: _unref(translate)('logout'),
              onClick: handleClickMenu,
              className: 'fw-bold',
              type: 'secondary'
            }, null, 8, ["title"])
          ])
        ])
      ], 32)
    ])
  ]))
}
}

})